import get from 'lodash/get'
import set from 'lodash/set'
import React from 'react'
import { createRoot } from 'react-dom/client';

export default class ReactRenderer {

  static components = {}

  static registerComponent (name, component) {
    if (get(ReactRenderer.components, name)) {
      throw new Error(`Component ${name} already registered`)
    }

    set(ReactRenderer.components, name, component)
  }

  static render () {
    document.querySelectorAll('[data-react-class]').forEach((element) => {
      let components = this.components

      let Component = get(components, element.dataset.reactClass)
      let props = JSON.parse(element.dataset.reactProps)

      if (typeof Component === 'undefined' || Component === null) {
        return console.warn('Failed to mount react component: ' + element.dataset.reactClass)
      }

      let JSX = (<Component {...props}/>)

      const root = createRoot(element)

      root.render(JSX)
    })
  }
}